import { ReactNode } from 'react';

interface AnalyticsRowProps {
  title: string;
  value?: string | number | ReactNode;
  valueColor?: string;
  isHeader?: boolean;
}

export const AnalyticsRow = ({ title, value, valueColor = 'text-black', isHeader = false }: AnalyticsRowProps) => (
  <div className="flex justify-between gap-4 border-b border-[#9A9A9A26] pb-[10px]">
    <span className="text-[18px] text-grey-secondary leading-[1.4]">{title}</span>
    {!isHeader && value !== undefined && (
      <span className={`text-[20px] font-bold ${valueColor}`}>
        {value}
      </span>
    )}
  </div>
);
